import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { rand, randProductName } from '@ngneat/falso'
import type { SchemaAttributes } from '../types.js'

type SimpleConsultationItemAttributes =
  SchemaAttributes<'SimpleConsultationItem'>

export const model = Model as ModelDefinition<SimpleConsultationItemAttributes>

export const factory = Factory.extend<SimpleConsultationItemAttributes>({
  name() {
    return randProductName()
  },
  type_code() {
    return rand(['PROCEDURE', 'FOOD', 'SUPPLY', 'MEDICINE'])
  },
})
